<template>
  <div class="pricemark-container">
  <vggrid ref="xGrid" :random="Math.floor(Math.random() * 999999)"  class="vggrid" :list="pusComList" flexname=""
          :cols="cols"
          :showfooter="false"
          :showPage="false" :resizable="true"
          @cellClick="cellClick">
    <template slot="btn">
        <el-button v-show="+project.prsflg === 1 || +project.prsflg"  style="float: right;" type="primary" size="small" @click="exportToExcel" icon="el-icon-download">导出EXCEL</el-button>
        <div  v-if="project.projectstatus < 30 && +project.projectdoneflg !== 3" class="pricemark-grid-btn"><vxe-button class="vxe-btn" type='primary' @click="submit" :loading="btnLoading">提交</vxe-button></div>
    </template>
  </vggrid>
    <!--<div v-if="project.projectstatus < 30 && +project.projectdoneflg !== 3">-->
      <!--<div class="pricemark-grid-btn"><vxe-button class="vxe-btn" @click="submit" :loading="btnLoading">提交</vxe-button></div>-->
      <!--<div class="split-line"></div>-->
    <!--</div>-->
    <el-dialog :close-on-click-modal="false"  title="报价记录" :visible.sync="dialogVisible" width="800px"
               :modal-append-to-body="false">
      <pbr-list-form :projectid="psu.projectid" :project='project' :comid="psu.psucomid"></pbr-list-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false"  @close="onClose" title="履约得分表" :visible.sync="performanceScoreShowDialogVisible" width="800px"
               :modal-append-to-body="false">
      <span>供应商： {{ currentPsu.comfullname }}</span>
      <el-divider></el-divider>
      <div style="display: flex;justify-content: center;">
        <el-row :gutter="20">
          <el-form :model="currentPsu" ref="ruleForm" :rules="rules" label-width="0">
            <el-col :span="6">
              <div style="display: flex;flex-direction: column;align-items: center;">
                <span style="font-weight: bold; font-size: 16px;margin-bottom: 12px;">履约基础分</span>
                <el-form-item prop="psuperformancebasicas">
                  <el-input v-model="currentPsu.psuperformancebasicas" 
                            :disabled="+project.projectstatus >= 30"
                            @blur="scoreFixed($event, 'psuperformancebasicas')"
                            >
                  </el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="4" >
              <div style="display: flex;justify-content: center;flex-direction: column;">
                <div style="font-weight: bold;font-size: 32px;text-align: center;width: 100%;">
                  {{ currentPsu.operate ? '+' : '-' }}
                </div>
                
                <el-form-item prop="operate" style="text-align: center;">
                  <el-switch v-model="currentPsu.operate" class="tool" active-text="+" inactive-text="-" :disabled="+project.projectstatus >= 30"></el-switch>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div style="display: flex;flex-direction: column;align-items: center;">
                <span style="font-weight: bold; font-size: 16px;margin-bottom: 12px;">履约加减法</span>
                <el-form-item prop="psuperformanceadjustas">
                  <el-input @blur="scoreFixed($event, 'psuperformanceadjustas')" v-model="currentPsu.psuperformanceadjustas" :disabled="+project.projectstatus >= 30"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="3" style="margin-top: 24px;">
              <span style="font-weight: bold;font-size: 32px;text-align: center;width: 100%;">=</span>
            </el-col>
            <el-col :span="4">
              <div style="display: flex;flex-direction: column;align-items: center;">
                <span style="font-weight: bold; font-size: 16px;margin-bottom: 12px;">履约得分</span>
                <span style="font-weight: bold; font-size: 22px;">{{ +project.projectstatus >= 30 ? currentPsu.psuperformanceas :  score}}</span>
              </div>
            </el-col>
          </el-form>
      </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
         <el-button @click="performanceScoreShowDialogVisible = false">取消</el-button>
         <el-button type="primary" @click="onClick" v-show="+project.projectstatus < 30">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  const validatePsuperformancebasicas = (rule, value, callback) => {
    if (value === '') {
      callback(new Error('请输入履约基础分'))
    }
    if (isNaN(+value)) {
      callback(new Error('请输入数值'))
    }
    callback()
  }
  const validatePsuperformanceadjustas = (rule, value, callback) => {
    if (value === '') {
      callback(new Error('请输入履约加减分'))
    }
    if (isNaN(+value)) {
      callback(new Error('请输入数值'))
    }
    callback()
  }
  import request from '@/utils/request'
  import vggrid from '../common/vggrid'
  import common from '@/mixin/common'
  import PbrListForm from './pbrListForm'
  import utils from '../../assets/js/utils'
  import dayjs from 'dayjs'
  import * as XLSX from 'xlsx'
  import FileSaver from 'file-saver'
  export default {
    name: 'pricemark',
    props: {
      projectid: {},
      project: {
        default: {}
      },
      activeName: {
        default: ''
      }
    },
    mixins: [common],
    data () {
      return {
        // project: {},
        rules: {
          psuperformancebasicas: [
            { validator: validatePsuperformancebasicas, trigger: 'blur' }
          ],
          psuperformanceadjustas: [
            { validator: validatePsuperformanceadjustas, trigger: 'blur' }
          ]
        },
        dialogVisible: false,
        psu: '',
        isEdit: true,
        pusComList: [],
        btnLoading: false,
        cols: [],
        performanceScoreShowDialogVisible: false,
        currentPsu: {},
        form: {
          psuperformancebasicas: 0,
          psuperformanceadjustas: 0,
          psuperformanceas: 0,
          psuperformanceoperate: '1',
          operate: true
        }
      }
    },
    created () {
      this.getCols()
      this.getPsuComList()
    },
    activated() {
      this.getCols()
      this.getPsuComList()
    },
    mounted () {
    },
    watch: {
      activeName () {
        console.log(this.activeName)
        if(this.activeName === 'pfxm') {
          this.getPsuComList()
        }
      }
    },
    computed:{
      score () {
        this.currentPsu.psuperformanceas = this.currentPsu.operate ? +this.currentPsu.psuperformancebasicas + +this.currentPsu.psuperformanceadjustas : +this.currentPsu.psuperformancebasicas - +this.currentPsu.psuperformanceadjustas
        if (this.currentPsu.psuperformanceas) {
          this.currentPsu.psuperformanceas = this.currentPsu.psuperformanceas.toFixed(2)
          return utils.comdify(this.currentPsu.psuperformanceas + '')
        }
        else  return utils.comdify(0 + '')
      },
      prsName(){
        // 竞拍方案，比选文件
        if(+this.project.prsflg === 1 || +this.project.prsflg === 3){
          return {
            gys:'竞价单位',
            filename:'竞价方案'
          }
        }
        else if(+this.project.prsflg === 4 || +this.project.prsflg === 5){
          return {
            gys:'竞拍单位',
            filename:'竞拍方案'
          }
        }
        else if(+this.project.prsflg === 6){
          return {
            gys:'比选单位',
            filename:'评审文件'
          }
        } else{
          return {
            gys:'竞价单位',
            filename:'竞价方案'
          }
        }
      }
    },
    components: {vggrid, PbrListForm},
    methods: {
      exportToExcel () {
        
        // const worksheet = XLSX.utils.aoa_to_sheet([
        //   ["A1", "B1", "C1"],
        //   ["A2", "B2", "C2"],
        //   ["A3", "B3", "C3"]
        // ]);
        const projectquotationmodeDesc = ['','最终报价', '上浮率%', '下浮率%', '折扣率%']
        let data = this.pusComList.map((item, index) => {
          let obj = {}
          obj['序号'] = index + 1
          obj['供应商'] = item.comfullname
          obj[projectquotationmodeDesc[+this.project.projectquotationmode]] = +this.project.projectquotationmode === 1 ?  item.psuamt : item.psupricerate
          obj['报价时间'] = item.psuoffertime
          if (+this.project.projectdoneflg === 4) { 
            obj['履约分'] = item.psuperformanceas
            obj['价格分'] = item.diffScore
          }
          obj['得分'] = item.psuas
          obj['排名'] = item.psubidorder
          return obj
        })
        const cols = ['序号', '供应商', projectquotationmodeDesc[+this.project.projectquotationmode] , '报价时间', '得分', '排名']
        // if (this.project.projectdoneflg === 6) {
        if (+this.project.projectdoneflg === 4) {
          cols.splice(4,0, '履约分')  
          cols.splice(5,0, '价格分')  
        }
        // }
        const worksheet = XLSX.utils.json_to_sheet(
          data,
          {
            header: cols
          }
        );
        
        const max_width = data.reduce((w, r) => Math.max(w, r['供应商'].length), 10);
        worksheet["!cols"] = [{wch: 10} ,{ wch: max_width * 2.2 }, { wch: 12 },  { wch: 26 } ];
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // 生成blob对象
        const blob = new Blob([XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' })], { type: 'application/octet-stream' });
        var wbout = XLSX.write(workbook, {bookType: "xlsx",bookSST: true,type: "array"});
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          this.project.projectname + "评审表.xlsx"
        )
      },
      downAppend (row) {
        this.downFile(row.appendurl, row.appendid)
      },
      getCols () {
        // projectquotationmode
        this.cols = []
        if (+this.project.prsflg === 2) {
          this.cols = [
            {type: 'index', fieldtype: 'I', title: '行号', calculExpr: '', width: 50},
            {field: 'comfullname', fieldtype: 'C', title: '供应商', calculExpr: '', addNewRowFlg: false},
            {
              title: `${this.prsName.filename}`, showOverflow: true,
              slots: {
                default: 'default',
                default: ({row}) => {
                  return [
                    <a style = "color: #2f74ff;cursor: pointer;" onClick = {this.downAppend.bind(this, row) }>{row.appendfilename}</a>
                ]
                }
              }
            },
            {field: 'psumat', title: '最终报价', calculExpr: '', addNewRowFlg: false, width: 100},
            {field: 'psuas', title: '得分', calculExpr: '', addNewRowFlg: false, width: 100},
            {field: 'psuoffertime', fieldtype: 'C', title: '报价时间', calculExpr: '', addNewRowFlg: false, width: 200},
            {field: 'psubidorder', title: '排名', calculExpr: '', addNewRowFlg: false, width: 100},
          ]
        } else {
          this.cols = [
            {type: 'index', fieldtype: 'I', title: '行号', calculExpr: '', width: 50},
            {field: 'comfullname', fieldtype: 'C', title: '供应商', calculExpr: '', addNewRowFlg: false},
            {
              title: '报价记录', width: 120, showOverflow: true,
              slots: {
                default: 'default',
                default: ({row}) => {
                  return [<vxe-button type="primary" onClick={this.priceRecord.bind(this,row)}>点击显示</vxe-button>]
                }
              }
            },
            {
              title: `${this.prsName.filename}`, showOverflow: true,
              slots: {
                default: 'default',
                default: ({row}) => {
                  return [
                    <a style = "color: #2f74ff;cursor: pointer;" onClick = {this.downAppend.bind(this, row) }>{row.appendfilename}</a>
                ]
                }
              }
            },
            // {field: 'psuamt', title:'最终报价', calculExpr: '',visible:pflg, addNewRowFlg: false, width: 100},
            // {field: 'psupricerate', title:'下浮率', calculExpr: '',visible:sflg, addNewRowFlg: false, width: 100},
            {field: 'psuoffertime', fieldtype: 'C', title: '报价时间', calculExpr: '', addNewRowFlg: false, width: 200},
            {field: 'psuas', title: '得分', calculExpr: '', addNewRowFlg: false, width: 100},
            {field: 'psubidorder', title: '排名', calculExpr: '', addNewRowFlg: false, width: 100},
          ]
          if(+this.project.projectquotationmode === 1){
            this.cols.splice(4,0,{field: 'psuamt', title:'最终报价', calculExpr: '', addNewRowFlg: false, width: 100})
          }else if(+this.project.projectquotationmode === 2){
            this.cols.splice(4,0,{field: 'psupricerate', title:'上浮率%', calculExpr: '', addNewRowFlg: false, width: 100})
          }else if(+this.project.projectquotationmode === 3){
            this.cols.splice(4,0,{field: 'psupricerate', title:'下浮率%', calculExpr: '', addNewRowFlg: false, width: 100})
          }else if(+this.project.projectquotationmode === 4){
            this.cols.splice(4,0,{field: 'psupricerate', title:'折扣率%', calculExpr: '', addNewRowFlg: false, width: 100})
          }
          if(+this.project.prsflg === 1 || +this.project.prsflg === 3 || +this.project.prsflg === 4 || +this.project.prsflg === 5){
            const len = this.cols.length 
            if (+this.project.projectdoneflg === 4) {
              this.cols.splice(len-2,0,{
              title: '履约分', width: 160, showOverflow: true,
              slots: {
                default: 'default',
                default: ({row}) => {
                  return [<div><span style='margin-right: 8px'>{row.psuperformanceas}</span><vxe-button type="primary" onClick={this.onPerformanceScoreShowClick.bind(this,row)}>得分明细</vxe-button></div>]
                }
              }
            })
            this.cols.splice(len-1,0,{field: 'diffScore', title: '价格分', calculExpr: '', addNewRowFlg: false, width: 100},)
            }
          }
        }
      },
      submit () {
        this.$confirm('是否提交，提交后不可修改？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(async() => {
          let data = await request({
            url: '/xmgl/project/updatePsuListPrice',
            method: "post",
            data: this.pusComList
          })
          if (data.issuccess === 1) {
            this.$message.success('提交成功')
            this.project.projectstatus = 30
            this.$emit('change')
          } else {
            this.$message.error('提交失败')
          }
        })
      },
      priceRecord(row) {
        this.dialogVisible = true
        this.psu = row
        // this.$router.push({name: 'pbrListForm', params: {comid: row.psucomid, projectid: row.projectid, type: 1}})
      },
      async getPsuComList () {
        await this.getCols()
        this.pusComList = await request({
          url: '/xmgl/project/getPsuListFromPriceMark',
          method: "get",
          params: {
            projectid: this.projectid,
            projectisqcheck: this.project.projectisqcheck
          }
        })
        this.pusComList.map(v => {
          v.psuamt = utils.comdify(v.psuamt)
          v.psuoffertime = dayjs(v.psuoffertime).format('YYYY-MM-DD HH:mm:ss SSS')
        })
      },
      async cellClick (row) {
        // this.psu = row.row
      },
      
      async onClick() {
        this.$refs['ruleForm'].validate(async (valid) => {
          if (valid) {
            if (+this.currentPsu.psuperformanceas > +this.project.projectperformancescore) {
              this.$message.error(`履约分不能大于当前项目的履约绝对值:${+this.project.projectperformancescore}!当前履约分:${+this.currentPsu.psuperformanceas}`)
              return false
            }
            if (this.currentPsu.psuperformanceas < 0) {
              this.$message.error('履约分不能为负值')
              return false
            }
            const score = +this.currentPsu.diffScore + +this.currentPsu.psuperformanceas
            await request({
              method: 'post',
              url: '/cwgl/psuproject/savePsuperformanceas',
              data: {
                psuas: this.currentPsu.psuas,
                psuperformancebasicas: this.currentPsu.psuperformancebasicas,
                psuperformanceadjustas: this.currentPsu.psuperformanceadjustas,
                psuperformanceas: this.currentPsu.psuperformanceas,
                psuperformanceoperate: +this.currentPsu.operate,
                psuid: this.currentPsu.psuid,
                psuprojectid: this.project.projectid,
                psuas: score
              }
          })
            this.$message.success('保存成功')
            this.performanceScoreShowDialogVisible = false
            await this.getPsuComList()
          } else {
            console.log('error submit!!');
            return false;
          }
        });
        
      },
      onPerformanceScoreShowClick (row) {
        this.currentPsu = JSON.parse(JSON.stringify(row))
        this.performanceScoreShowDialogVisible = true
        this.$set(this.currentPsu, 'operate', row.psuperformanceoperate === null ? true : Boolean(+row.psuperformanceoperate))
        this.$refs['ruleForm'] && this.$refs['ruleForm'].resetFields()
      },
      scoreFixed (el, name) {
        let inputVal = el.target.value || ''
        this.currentPsu[name] = Number(inputVal).toFixed(2)
      },
      onClose () {
        this.currentPsu = {}
      }
    },
  }
</script>
<style lang="scss" scoped>
  .pricemark-grid-btn {
    /*text-align: right;*/
    /*padding-right: 10px;*/
    /*padding-top: 10px;*/
    padding-left: 10px;
  }
</style>
<style lang="scss">
.tool > .el-switch__label span{
  font-size: 20px !important;
}
</style>
